import { AppFilter } from '@components/app-filter';
import { useMemberFilters } from '@modules/members/hooks/use-filter-members';
import { FilterMembersProps } from '@modules/members/members.types';
import { Select } from 'antd';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { RiArrowDownSLine } from 'react-icons/ri';

export function FilterMembers({ setFilter }: FilterMembersProps) {
  const { isFilterOpen, setFilterOpen, filters } = useMemberFilters(setFilter);
  const { t } = useTranslation();
  return (
    <div onMouseDown={(e) => e.stopPropagation()} className="relative">
      <div className="fixed z-50">
        <AppFilter
          isFilterOpen={isFilterOpen}
          setFilterOpen={setFilterOpen}
          filters={filters}
          showAppliedFilter={false}
        ></AppFilter>
      </div>
      <Select
        onClick={() => setFilterOpen((prev) => !prev)}
        placeholder={t('filter_by').toUpperCase()}
        variant="borderless"
        styles={{ popup: { root: { display: 'none' } } }}
        size="small"
        suffixIcon={<RiArrowDownSLine />}
        className={clsx(
          'bg-white rounded-4xl placeholder:text-slate-950! font-semibold px-2! border border-gray-800 h-7!',
          isFilterOpen && 'bg-primary-50!'
        )}
      />
    </div>
  );
}
